import React, {useEffect, useState} from 'react';
import './scss/contract-add.scss';
import ProcessModel from '../models/process';
import ProcessAddContractProp from './properties/process-add-contract';
import Utils from '../common/utils';
import FullScreenLoader from './full-screen';
import SandraJsAPI from "../services/sandraJsAPI";
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function ProcessAddContract({
                                standard, hash, blockchain, setStatusMessage, metadataType
                            }: ProcessAddContractProp):
    React.ReactElement {
    const processesInit: ProcessModel[] = [];
    const [processes, setProcesses] = useState(processesInit);
    const [processId, setProcessId] = useState('');
    const [startBlock, setStartBlock] = useState('');
    const [endBlock, setEndBlock] = useState('');
    const [blockRange, setBlockRange] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorClass, setSetErrorClass] = useState('hide');

    function validateForm() {
        if (!processId) {
            setErrorMessage('Please select process');
            setSetErrorClass('error mb-4');
            return false;
        }

        if (startBlock && !Utils.validateNumber(startBlock)) {
            setErrorMessage('Please enter valid start block number');
            setSetErrorClass('error mb-4');
            return false;
        }
        if (endBlock && !Utils.validateNumber(endBlock)) {
            setErrorMessage('Please enter valid end block number');
            setSetErrorClass('error mb-4');
            return false;
        }

        if (startBlock && endBlock && Number(startBlock) > Number(endBlock)) {
            setErrorMessage('Start block number should be less than or equal to end block');
            setSetErrorClass('error mb-4');
            return false;
        }
        if (blockRange && !Utils.validateNumber(blockRange)) {
            setErrorMessage('Please enter valid block range');
            setSetErrorClass('error mb-4');
            return false;
        }

        return true;
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        if (validateForm()) {
            setIsLoading(true);
            SandraJsAPI.addContractToProcess({
                endBlock,
                blockRange,
                status: 'active',
                startBlock,
                standard,
                hash,
                lastUpdateTime: '',
                lastBlockSaved: '',
                lastBlockProcessed: '',
                collections: [],
                metadataType
            }, processId).then((result) => {
                console.log(result);
                setIsLoading(false);
                window.location.reload();
            }).catch((error) => {
                setIsLoading(false);
                setStatusMessage(error, StatusMessageTypeEnum.error);
                window.scrollTo(0, 0);
            });
        }
    };

    useEffect(() => {
        setIsLoading(true);
        SandraJsAPI.getJetskiProcesses()
            .then((result) => {
                if (result.error) {
                    setErrorMessage(result.error.message);
                } else {
                    //console.log(result.data.processes);
                    // eslint-disable-next-line max-len
                    //const filteredProcesses = result.data?.processes?.filter((process: ProcessModel) => (String(process.id).indexOf("_canonize") >= 0) && process.blockchain.toLowerCase() === blockchain.toLowerCase());

                    setProcesses(result.data);
                }
                setIsLoading(false);
            })
            .catch((reason) => {
                setIsLoading(false);
                setErrorMessage(reason.message);
            });
    }, []);

    return (
        <div className="rounded add-process-box loading-wrapper">
            {isLoading ? <FullScreenLoader/> : <div/>}
            <h6 className="p-1 mb-3">Add To Process</h6>
            {(processes && processes?.length > 0) ? (
                <form onSubmit={handleSubmit}>
                    <div className={errorClass}>{errorMessage}</div>
                    <div className="mb-2">
                        <select
                            aria-label="Select Process"
                            onChange={(e) => setProcessId(e.target.value)}
                            className="form-select mt-1 d-block"
                            value={processId}
                        >
                            <option selected>Select Process</option>
                            {processes?.map((item) => {
                                    if ((String(item.id).indexOf("_canonize") >= 0) && item.blockchain.toLowerCase() === blockchain.toLowerCase()) {
                                        return (<option className="" value={item.id}>
                                            {item.id}
                                        </option>)
                                    }
                                }
                            )}
                        </select>
                        <span className="text-sm-light fst-italic p-1 pt-2 mb-3 d-block">Select jetski process for this contract</span>
                    </div>
                    <div className="mb-0">
                        <div className="row">
                            <div className="col-6">
                                <label htmlFor="startBlock" className="form-label w-100">
                                    Start Block (optional)
                                    <input
                                        type="text"
                                        id="startBlock"
                                        className="form-control mt-1 d-block"
                                        value={startBlock}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        onChange={(e) => {
                                            setStartBlock(e.target.value);
                                        }}
                                    />
                                    <span className="text-sm-light fst-italic p-1 d-block">Start scan from this block number, default value is 0</span>
                                </label>
                            </div>
                            <div className="col-6">
                                <label htmlFor="endBlock" className="form-label w-100">
                                    End Block (optional)
                                    <input
                                        type="text"
                                        id="endBlock"
                                        className="form-control mt-1 d-block"
                                        value={endBlock}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        onChange={(e) => {
                                            setEndBlock(e.target.value);
                                        }}
                                    />
                                    <span className="text-sm-light fst-italic p-1 d-block">Scan to this block number, if not set then jetski process should continues scan for till latest block</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="mb-2 w-100">
                        <label htmlFor="blockRange" className="form-label w-100">
                            Block Range (optional)
                            <input
                                type="text"
                                id="blockRange"
                                className="form-control"
                                value={blockRange}
                                onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    setBlockRange(e.target.value);
                                }}
                            />
                            <span className="text-sm-light fst-italic p-1 d-block">Range of block number to be scanned per request, default value is 5000</span>
                        </label>
                    </div>
                    <button type="submit" className="btn btn-dark">Add</button>
                </form>
            ) : (
                <div>
                    {isLoading ? <div className="text-sm-light fst-italic ms-1">Loading..</div> : (
                        <div className="ps-1 fst-italic">
                            No process found, please add a process from
                            <a href="/jetski/all"> Jetski </a>
                            {' '}
                            tab.
                        </div>
                    )}
                </div>
            )}

        </div>
    );
}

export default ProcessAddContract;
